import React, { useContext } from 'react';
export var StylesContext = React.createContext({
    ready: false,
    set: null,
    get: null,
    getDefaultValue: null,
    reset: null,
    resetAll: null,
    changeSiteColors: null,
    getStylesForAllBreakpoints: null,
});
export var StylesConsumer = StylesContext.Consumer;
export var useStylesContext = function () {
    var context = useContext(StylesContext);
    if (!context) {
        throw new Error('useStylesContext must be used within a StylesProvider');
    }
    return context;
};
//# sourceMappingURL=StylesContext.js.map